import { PricingRangeBus } from './PricingRangeBus';
import { BaseBus } from './BaseBus';
export class CustomPricingBus extends BaseBus
{
    constructor(data: CustomPricingBus = null) {
        super(data);
        
    }
    pricingRanges: PricingRangeBus[];
}
